<template>
  <span class="day-item-date">
    <small class="date-from">
      <strong v-if="day.date_from !== day.date_to">{{ $t('day.from') }}</strong>
      {{ humanDateFormat(day.date_from, false, false) }}
      <span class="date-from-name">({{ day.date_from_name }})</span>
    </small>

    <template v-if="day.date_from !== day.date_to">
      <br>
      <small class="date-to">
        <strong>{{ $t('day.to') }}</strong>
        {{ humanDateFormat(day.date_to, false, false) }}
        <span class="date-to-name">({{ day.date_to_name }})</span>
      </small>
    </template>
  </span>
</template>

<script>
import CalendarUtils from './../helpers/CalendarUtils';

export default {
  name: 'day-item-date',
  props: [
    'day'
  ],
  methods: {
    humanDateFormat (date) {
      if (!date) {
        return '';
      }

      return CalendarUtils.humanDateFormat(date, false, false);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.day-item-date {
  padding-right: 1rem;

  .date-from,
  .date-to {
    display: inline-block;
    text-align: center;

    &-name {
      color: $color-text-light;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Day.vue